import React, { useEffect, useState } from "react";
import { Form, Button, Drawer } from "antd";
import { vsmNotify } from "../../../../config/messages";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import debounce from "lodash/debounce";
import FormComponent from "./FormComponent";

const AddComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		ManageInsuranceSegmentStore: { AddData },
		ManageZFormsStore,
		InsuranceProductStore,
		InsuranceProductStore: { getModelListByBrand },
	} = useStore();
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);
	const [fetchModel, setFetchModel] = useState(true);
	const [fetchCompnay, setFetchCompnay] = useState(true);
	const [fetchSegment, setFetchSegment] = useState(true);


	const [modelList, setModelList] = useState([]);
	const [selectedmodelList, setselectedmodelList] = useState([]);

	useEffect(() => {
		if (fetchModel && props.visible) {
			getModelListByBrand({}).then((data) => {
				setModelList(data.list.data);
			})
			setFetchModel(false)
		}
	}, [getModelListByBrand, fetchModel, props.visible])



	useEffect(() => {
		if (fetchCompnay && props.visible) {
			ManageZFormsStore.getInsuranceCompanyList().then(() => setFetchCompnay(false))
		}
	}, [ManageZFormsStore, fetchCompnay, props.visible])


	useEffect(() => {
		if (fetchSegment && props.visible) {
			InsuranceProductStore.getSegmentsList().then(() => setFetchSegment(false))
		}
	}, [InsuranceProductStore, fetchSegment, props.visible])

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		if (validate()) {
			data.model_ids = selectedmodelList.map((obj) => obj.id);
			setSaving(true);
			AddData(data)
				.then((data) => {
					close();
					vsmNotify.success({
						message: data.STATUS.NOTIFICATION[0],
					});
				})
				.catch((e) => {
					if (e.errors) {
						form.setFields(e.errors);
					}
				})
				.finally(() => setSaving(false));
		}
		else {
			vsmNotify.error({
				message: "Please select at least one model",
			});
		}
	};

	const validate = () => {
		let isValid = true;
		if (selectedmodelList.length <= 0) {
			isValid = false;
		}
		return isValid;
	}

	// check for valid form values then accordingly make save button disable / enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setModelList([]);
		setselectedmodelList([]);
		setFetchModel(true);
		setDisabled(true);
	};



	return (
		<Drawer
			className="addModal"
			title="New Segment for Insurance"
			width="70%"
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onClose={close}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					disabled={disabled}
					form="addInsuranceSegmentForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>,
			]}
		>
			<FormComponent
				form={form}
				id="addInsuranceSegmentForm"
				selectedmodelList={selectedmodelList}
				modelList={modelList}
				setModelList={setModelList}
				setselectedmodelList={setselectedmodelList}
				handleSubmit={handleSubmit}
				handleChange={handleChange}
			/>
		</Drawer>
	);
});

export default AddComponent;
